import React from "react";

export default function SummaryCards({
  monthlyEntries,
  monthlyWeight,
  approvedCount,
  pendingCount,
  approvalRate,
  growthPercentage,
}) {
  const growthClass =
    growthPercentage >= 0 ? "green" : "red";

  return (
    <div className="flex flex-wrap">

      <div className="w-100 w-50-m w-20-l pa2">
        <article className="bg-white shadow-4 br3 pa3 tc">
          <div className="gray f6">
            Monthly Records
          </div>

          <div className="f2 fw7 blue">
            {monthlyEntries}
          </div>
        </article>
      </div>

      <div className="w-100 w-50-m w-20-l pa2">
        <article className="bg-white shadow-4 br3 pa3 tc">
          <div className="gray f6">
            Monthly Weight
          </div>

          <div className="f2 fw7 green">
            {monthlyWeight.toFixed(2)} KG
          </div>
        </article>
      </div>

      <div className="w-100 w-50-m w-20-l pa2">
        <article className="bg-white shadow-4 br3 pa3 tc">
          <div className="gray f6">
            Approved
          </div>

          <div className="f2 fw7 dark-green">
            {approvedCount}
          </div>
        </article>
      </div>

      <div className="w-100 w-50-m w-20-l pa2">
        <article className="bg-white shadow-4 br3 pa3 tc">
          <div className="gray f6">
            Pending
          </div>

          <div className="f2 fw7 orange">
            {pendingCount}
          </div>
        </article>
      </div>

      <div className="w-100 w-50-m w-20-l pa2">
        <article className="bg-white shadow-4 br3 pa3 tc">
          <div className="gray f6">
            Approval Rate
          </div>

          <div className="f2 fw7 purple">
            {approvalRate.toFixed(1)}%
          </div>
        </article>
      </div>

      <div className="w-100 pa2">
        <article className="bg-white shadow-4 br3 pa3 tc">
          <div className="gray f6">
            Growth vs Last Month
          </div>

          <div className={`f2 fw7 ${growthClass}`}>
            {growthPercentage.toFixed(1)}%
          </div>
        </article>
      </div>

    </div>
  );
}